import { Injectable, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FilterListingService {
  filterData: {
    searchGlobal: {
      filterBy: string;
      searchBy: string;
    };
    advancedFilter: any;
  };
  locationName: string;
  filterChanges$ = new Subject<any>();
  tableEvents: any;
  activeTab: any;
  activeUserAssetMgmtTab: any;
}
